import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b74056ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator_wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" })
], -1))
const _hoisted_2 = {
  ref: "stockTitleInfo",
  class: "stock_top_info"
}
const _hoisted_3 = { class: "title_24B" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_14R" }, " 나와 함께 성장할 미래의 유니콘을 찾아보세요 ", -1))
const _hoisted_5 = { class: "stock_top_rank" }
const _hoisted_6 = { class: "row vote_row entire" }
const _hoisted_7 = { class: "row_inner_info" }
const _hoisted_8 = { class: "stock_sort_box" }
const _hoisted_9 = ["checked"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 인기순 ")
const _hoisted_12 = ["checked"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 기업가치순 ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_info" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "main_14R" }, "기업가치는 공개된 자료를 기반으로 계산한 추정 값으로, 실제 기업가치와 차이가 있을 수 있습니다")
], -1))
const _hoisted_16 = { class: "space-between" }
const _hoisted_17 = { class: "entire_company_left" }
const _hoisted_18 = { class: "c_logo" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_21 = { class: "right-space-between" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "entire_company_info" }
const _hoisted_24 = { class: "list_17M" }
const _hoisted_25 = { class: "right_bottom" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "small_leaf_g leaf_g",
  src: "/assets/icon/small_leaf_g.png"
}, null, -1))
const _hoisted_27 = { class: "green" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "·", -1))
const _hoisted_29 = { class: "main_13R" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0px 8px","color":"#D9DEE8","font-size":"10px"} }, "|", -1))
const _hoisted_32 = { class: "charcoal" }
const _hoisted_33 = { class: "ion-activatable ripple-parent star_padding" }
const _hoisted_34 = ["disabled", "onClick"]
const _hoisted_35 = {
  key: 0,
  class: "star",
  src: "/assets/icon/star_b.png"
}
const _hoisted_36 = {
  key: 1,
  class: "star",
  src: "/assets/icon/star_g.png"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, " 전체회사 " + _toDisplayString(_ctx.stockItemsCount), 1),
      _hoisted_4
    ], 512),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", {
                  class: "radio-container",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.radioBtnClick(1)))
                }, [
                  _createElementVNode("input", {
                    type: "radio",
                    name: "chooseAccount",
                    checked: _ctx.stockSort === 'popular'
                  }, null, 8, _hoisted_9),
                  _hoisted_10,
                  _hoisted_11
                ]),
                _createElementVNode("label", {
                  class: "radio-container",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.radioBtnClick(2)))
                }, [
                  _createElementVNode("input", {
                    type: "radio",
                    name: "chooseAccount",
                    checked: _ctx.stockSort === 'value'
                  }, null, 8, _hoisted_12),
                  _hoisted_13,
                  _hoisted_14
                ])
              ]),
              _hoisted_15
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.stockSort==='popular' ? _ctx.stockItemsPaging : _ctx.stockItemsValuationPaging), (stock) => {
              return (_openBlock(), _createElementBlock("div", {
                key: stock.stockItemId,
                class: "entire_company"
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("img", {
                        src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                        onerror: "this.src='/assets/icon/company_default_img.png'",
                        class: "img-responsive img-circle"
                      }, null, 8, _hoisted_19),
                      _hoisted_20
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", {
                      class: "entire_company_right",
                      onClick: ($event: any) => (_ctx.useCompanyModal(stock.stockItemId))
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(stock.stockItemName), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("span", _hoisted_27, _toDisplayString(Number(stock.avgPoint).toFixed(1)), 1),
                          _hoisted_28,
                          _createElementVNode("span", _hoisted_29, _toDisplayString(stock.count) + "명", 1),
                          (stock.minSellingPrice)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$filters.currency(stock.minSellingPrice)) + " 원 ", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 8, _hoisted_22),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("button", {
                        disabled: ~['mna','ipo'].indexOf(stock.companyStatus),
                        onClick: ($event: any) => (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.itemLikeCompany(stock.stockItemId))
                      }, [
                        (stock.likeFlag)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                          : (_openBlock(), _createElementBlock("img", _hoisted_36)),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ], 8, _hoisted_34)
                    ])
                  ])
                ])
              ]))
            }), 128)),
            _createVNode(_component_ion_infinite_scroll, {
              id: "infinite-scroll",
              threshold: "100px",
              disabled: !_ctx.hasMore,
              onIonInfinite: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadData($event)))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_infinite_scroll_content, { "loading-spinner": "bubbles" })
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}